export class FiscalFactory {
  constructor(instance) {
    this.instance = instance;
  }

  acesso() {
    return this.instance.get('/v1/fiscal/acesso');
  }

  listarEmitentes() {
    return this.instance.get('/v1/fiscal/emitentes');
  }

  criarEmitenteDaFazenda(data) {
    return this.instance.post('/v1/fiscal/emitentes/da-fazenda', data);
  }

  criarEmitente(data) {
    return this.instance.post('/v1/fiscal/emitentes', data);
  }

  atualizarEmitente(id, data) {
    return this.instance.put(`/v1/fiscal/emitentes/${id}`, data);
  }

  desabilitarEmitente(id) {
    return this.instance.delete(`/v1/fiscal/emitentes/${id}`);
  }

  atualizarRegimeEmitente(id, regimeTributario) {
    return this.instance.patch(`/v1/fiscal/emitentes/${id}/regime`, {
      regimeTributario,
    });
  }

  listarNotas(params) {
    return this.instance.get('/v1/fiscal/nfe', { params });
  }

  resumoNotas(params) {
    return this.instance.get('/v1/fiscal/nfe/resumo', { params });
  }

  obterNota(id) {
    return this.instance.get(`/v1/fiscal/nfe/${id}`);
  }

  pendenciasDaVenda(vendaId, params) {
    return this.instance.get(`/v1/fiscal/nfe/pendencias/${vendaId}`, {
      params,
    });
  }

  emitirDaVenda(data) {
    return this.instance.post('/v1/fiscal/nfe/da-venda', data);
  }

  emitir(data) {
    return this.instance.post('/v1/fiscal/nfe', data);
  }

  consultarNota(id) {
    return this.instance.post(`/v1/fiscal/nfe/${id}/consultar`);
  }

  cancelarNota(id, justificativa) {
    return this.instance.post(`/v1/fiscal/nfe/${id}/cancelar`, {
      justificativa,
    });
  }

  atualizarNcm(produtoId, data) {
    return this.instance.put(`/v1/fiscal/produtos/${produtoId}/ncm`, data);
  }
}